import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import _ from "lodash";
import {
  getInventoryProductList,
} from "../../store/actions/inventory.action";
import LoaderSpinner from "../common/Loader";
import { useDispatch, useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import { renderTableRow } from "../../config/utils";
import InfiniteScroll from "react-infinite-scroll-component";
import noImage from "../../assets/No-Image-Placeholder.png";
import { Tooltip as WmsTooltip } from "react-tooltip";
import { setLocalStorageItem } from "../../services/StorageService";
import BarcodeBtn from "../Inventory/Product/BarcodeBtn";
import BarcodeScannerComponent from "../common/BarCodeScanner";
import PropTypes from "prop-types";

const OutboundProductListingDialog = (props) => {
  const {
    showProductListingBox,
    handleCancel,
    setShowProductListingBox,
    formData,
    placeholderTxt,
    listType
  } = props;
  const [loader, setLoader] = useState(false);
  const { inventoryProductList, inventoryProductListStatus } = useSelector(
    (state) => state.InventoryManagement
  );
  const dispatch = useDispatch();
  const [productList, setProductList] = useState([]);
  const [sortOrder, setSortOrder] = useState("DESCENDING");
  const [sortingColumn, setSortingColumn] = useState("");
  const [searchTxt, setSearchTxt] = useState("");
  const [listingType, setListingType] = useState(2);
  const [productCondition, setProductCondition] = useState(1);
  const [userFilterChange, setUserFilterChange] = useState(false);
  const [imported, setImported] = useState([]);
  const [showScanner, setShowScanner] = useState(false);
  const [selectedScannedData, setSelectedScannedData] = useState({});

  let dataLoad = {
    sellerIdList: [],
    companyIdList: [],
  };
  const [filterData, setfilterData] = useState(
    JSON.parse(JSON.stringify(dataLoad))
  );
  const [totalPages, setTotalPages] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);

  useEffect(() => {
    if (formData?.items?.length) {
      const ids = formData.items.flatMap((item) => [
        item.productId,
        item.inboundProductId,
      ]).filter(Boolean); // Remove undefined/null
      setImported(ids);
    }
  }, [formData]);

  useEffect(() => {
    return () => {
      setProductList([]);
      setPageIndex(1);
      setTotalPages(0);
      setSortingColumn("");
      setSortOrder("DESCENDING");
      setSearchTxt("");
      setfilterData({
        sellerIdList: [],
        companyIdList: [],
      });
      setShowProductListingBox(false);
    };
  }, []);

  useEffect(() => {
    fetchProductList();
  }, [pageIndex, sortingColumn, sortOrder]);

  useEffect(() => {
    if (showProductListingBox) {
      setProductList([]);
      setPageIndex(1);
      setTotalPages(0);
      setSortingColumn("");
      setSortOrder("DESCENDING");
    }
    if (userFilterChange) {
      fetchProductList();
    }
  }, [listingType, productCondition]);

  useEffect(() => {
    if (inventoryProductList?.TotalRecords) {
      setTotalPages(Math.ceil(inventoryProductList?.TotalRecords / 50));
    }
  }, [inventoryProductList]);

  useEffect(() => {
    if (inventoryProductListStatus === "pending") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [inventoryProductListStatus]);

  useEffect(() => {
    if (
      inventoryProductList?.listInventoryEntity &&
      inventoryProductListStatus === 'success'
    ) {
      const newData = _.cloneDeep(inventoryProductList?.listInventoryEntity);

      // If first page, replace. Else append.
      setProductList((prevList) => (pageIndex === 1 ? newData : [...prevList, ...newData]));
    }
  }, [inventoryProductList?.listInventoryEntity, inventoryProductListStatus]);

  const handleFilterChange = (e, type) => {
    if (type === 'listingType') {
      setListingType(Number(e.target.value));
    }
    if (type === 'productCondition') {
      setProductCondition(Number(e.target.value));
    }
    setUserFilterChange(true);
  };

  const fetchProductList = () => {
    let data = {
      pageIndex: pageIndex,
      pageSize: 50,
      sortColumn: sortingColumn,
      sortOrder: sortOrder,
      searchKeyword: searchTxt,
      sellerIdList: _.map(filterData.sellerIdList, "id"),
      companyIdList: _.map(filterData.companyIdList, "Id"),
      listingType: listingType,
      productCondition: productCondition,
    };
    dispatch(getInventoryProductList(data));
  };

  const handleSortingColumn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setSortingColumn(sortColumn);
    setSortOrder(newSortOrder);
    setProductList([]);
    setfilterData({
      ...filterData,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
    });
  };

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return sortingColumn === columnName && sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return sortingColumn === columnName ? "active sortBtn" : "sortColumn sortBtn";
  };

  const handleSelect = (e, index) => {
    const { checked } = e.target;
    let listData = [...productList];
    listData[index].isChecked = checked;
    setProductList(listData);
  }

  const loadMoreData = () => {
    if (totalPages !== pageIndex) {
      setPageIndex(pageIndex + 1);
    }
  }

  const addSelectedProducts = () => {
    let listData = [...productList];
    let findChecked = listData.filter(item => item.isChecked);
    props.handleMultiProductSelect(findChecked);
    setShowProductListingBox(false);
  }

  const handleSearchFilter = () => {
    let data = {
      pageIndex: 1,
      pageSize: 50,
      sortColumn: '',
      listingType: listingType,
      sortOrder: 'DESCENDING',
      searchKeyword: searchTxt,
      sellerIdList: _.map(filterData.sellerIdList, "id"),
      companyIdList: _.map(filterData.companyIdList, "Id"),
      productCondition: listType === 'OUTBOUND' ? 0 : productCondition,
    };
    setProductCondition(listType === 'OUTBOUND' ? 0 : productCondition);
    setProductList([]);
    setPageIndex(1);
    setSortingColumn('');
    setSortOrder('DESCENDING');
    dispatch(getInventoryProductList(data));
  }

  const handleReset = () => {
    let data = {
      pageIndex: 1,
      pageSize: 50,
      sortColumn: '',
      sortOrder: 'DESCENDING',
      searchKeyword: '',
      sellerIdList: _.map(filterData.sellerIdList, "id"),
      companyIdList: _.map(filterData.companyIdList, "Id"),
      productCondition: 1,
    };
    setProductCondition(1);
    setProductList([]);
    setPageIndex(1);
    setSortingColumn('');
    setSortOrder('DESCENDING');
    setSearchTxt('');
    dispatch(getInventoryProductList(data));
  }

  const handleAddNewProduct = () => {
    let state = {
      data: 0,
      isEdit: true,
    }
    setLocalStorageItem('productObj', JSON.stringify(state));
    window.open('/inventory/0', '_blank');
  }

  const handleOpenScan = (e, inputKey) => {
    e.preventDefault();
    setSelectedScannedData({ formKey: inputKey });
    setShowScanner(!showScanner);
  }

  const handleScanSuccess = (scannedValue) => {
    setSearchTxt(scannedValue);
    setShowScanner(false);
  };

  return (
    <Modal
      {...props}
      size="xl"
      className="topUpModal productskuListing"
      centered
      backdrop="static"
      show={showProductListingBox}
      onHide={handleCancel}
    >
      <div className="top_modal_header_container no_mrg">
        <div>
          <span className="">Select Product SKU {" "}
            <i id='infoTitle' className="fa fa-info-circle ml-2 mr-3 fontFix" aria-hidden="true"></i>
            {loader && <LoaderSpinner />}
          </span>
          <div className="">
            <WmsTooltip
              anchorId={'infoTitle'}
              content={'We would like to confirm that the list you are currently viewing is associated with your account and belongs to you.'}
              place="right"
              className="tooltipWidth productInfo"
            />
          </div>
        </div>
        <div className="modalDeleteWrapper">
          <button
            type="button"
            onClick={() => handleCancel()}
            className="btn-close"
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div className="modal_container_rate_card seller-Modal productList">
        <div className="row filterContainer show searchBox mb-1">
          <div className="col-10 searchInputBox">
            <div className='flexCenter'>
              <input
                value={searchTxt}
                onChange={(e) => setSearchTxt(e.target.value)}
                className="form-control searchInput productSearchBox"
                placeholder={placeholderTxt ? placeholderTxt : 'Search by SKU, Outbound Id, Name, Consignment Type, Carrier Id, Tracking Number or Outbound Status'}
                onBlur={(e) => setSearchTxt(e.target.value.trim())}
                onKeyDown={(e) => e.key === "Enter" && handleSearchFilter()}
              />
              <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="searchTxt" selectedScannedData={selectedScannedData} />
            </div>
          </div>
          <button disabled={!searchTxt} className="btn cus-primary-transparent-btn clrBtn" onClick={handleReset}>Reset</button>
          <button
            className="btn cus-seconday-bg-btn marginLeft5 searchBtn handleSearchFilter"
            onClick={handleSearchFilter}
          >
            Search
          </button>
          <div className="inlineMob">
            <div className="col-12 searchInputBox">
              <button
                className="btn cus-seconday-bg-btn marginLeft5 searchBtn handleAddNewProduct"
                onClick={handleAddNewProduct}
              >
                Add New Product
              </button>
              <button
                className="btn cus-seconday-bg-btn marginLeft5 searchBtn refreshList"
                onClick={handleReset}
              >
                Refresh List
              </button>
            </div>
          </div>
        </div>

        <div className="row productTypeFilter mb-2 fontFix">
          <div className="col-4 searchInputBox">

            <fieldset
              id="listingType"
              className="codeOptions mt-2 codeOptions-mob-res row"
              onChange={(e) => handleFilterChange(e, 'listingType')}
            >
              <div className="col col-sm-12 col-md-12 displayFlex">
                <span className="mr-2">Filter By:</span> <input
                  type="radio"
                  value={2}
                  checked={listingType === 2}
                  name="listingType"
                  id="savePdf"
                />{" "}
                <label htmlFor="savePdf" className="mb-0 ml-1 ml-1">Item</label>
                <input
                  type="radio"
                  value={3}
                  checked={listingType === 3}
                  name="listingType"
                  id="print"
                />{" "}
                <label htmlFor="print" className="mb-0 ml-1">Box</label>

                <input
                  type="radio"
                  value={4}
                  checked={listingType === 4}
                  name="listingType"
                  id="savePrint"
                />{" "}
                <label htmlFor="savePrint" className="mb-0 ml-1">Pallet</label>
              </div>
            </fieldset>
          </div>
          {listType === 'OUTBOUND' && (
            <div className="col-4 searchInputBox">
              <fieldset
                id="productCondition"
                className="codeOptions mt-2 codeOptions-mob-res row"
                onChange={(e) => handleFilterChange(e, 'productCondition')}
              >
                <div className="col col-sm-12 col-md-12 displayFlex">
                  <span className="mr-2">Product By:</span> <input
                    type="radio"
                    value={0}
                    checked={productCondition === 0}
                    name="productCondition"
                    id="optionAll"
                  />{" "}
                  <label htmlFor="optionAll" className="mb-0 ml-1 ml-1">All</label>
                  <input
                    type="radio"
                    value={1}
                    checked={productCondition === 1}
                    name="productCondition"
                    id="optionInventory"
                  />{" "}
                  <label htmlFor="optionInventory" className="mb-0 ml-1">Inventory</label>
                  <input
                    type="radio"
                    value={2}
                    checked={productCondition === 2}
                    name="productCondition"
                    id="optionReturn"
                  />{" "}
                  <label htmlFor="optionReturn" className="mb-0 ml-1">Returns</label>
                </div>
              </fieldset>
            </div>
          )}
        </div>
        <div className="">
          {productList.length > 0 && (
            <InfiniteScroll
              next={loadMoreData}
              hasMore={totalPages === pageIndex ? false : true}
              loader={<p>Loading...</p>}
              height={300}
              pullDownToRefreshThreshold={10}
              dataLength={productList.length}
            >
              <div className="cus-page-content-sec">
                <div className="main_content_table_history noBrdr">
                  <div className="incomingTbl">
                    <Table
                      className={`table table-height tblOutbound horizontalAlignedTbl cus-left-right-col-layout table ${loader ? "disableTble" : ""
                        }`}
                    >
                      <thead className="tbl-btch">
                        <tr className="table-rw-batch">
                          <th width={"5%"}></th>
                          <th>Thumbnail</th>
                          <th width={"20%"}>
                            <button
                              className={handleSortingClass("productSku")}
                              onClick={(e) => handleSortingColumn(e, "productSku")}
                              id="productSku"
                            >
                              SKU {" "}
                              <i
                                className={handleSortingClass("productSku", true)}
                                aria-hidden="true"
                              ></i>
                            </button>
                          </th>
                          <th width={"20%"}>
                            <button
                              className={handleSortingClass("productName")}
                              onClick={(e) => handleSortingColumn(e, "productName")}
                              id="productName"
                            >
                              Name {" "}
                              <i
                                className={handleSortingClass("productName", true)}
                                aria-hidden="true"
                              ></i>
                            </button>
                          </th>
                          {listType === 'OUTBOUND' && (
                            <th width={"10%"}>
                              <button
                                className={handleSortingClass("productName")}
                                onClick={(e) => handleSortingColumn(e, "productName")}
                                id="productName"
                              >
                                Type {" "}
                                <i
                                  className={handleSortingClass("productName", true)}
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </th>
                          )}
                          <th width={"20%"}>Product Description</th>
                          <th width={"10%"}>
                            <button
                              className={handleSortingClass("quantity")}
                              onClick={(e) => handleSortingColumn(e, "quantity")}
                              id="quantity"
                            >
                              Quantity {" "}
                              <i
                                className={handleSortingClass("quantity", true)}
                                aria-hidden="true"
                              ></i>
                            </button>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="tbl-bt-body">
                        {productList?.map((item, index) => (
                          <tr key={item?.id}>
                            <td>
                              <input
                                type="checkbox"
                                className="checkProductInput"
                                checked={item.isChecked}
                                disabled={imported.includes(item.id)}
                                onChange={(e) => handleSelect(e, index)}
                              />
                            </td>
                            <td>
                              {item?.thumbnailUrl ? (
                                <img src={item?.thumbnailUrl} alt="product" style={{ width: '100px' }} />
                              ) : (
                                <img src={noImage} alt="" style={{ height: '75px' }} />
                              )}
                            </td>
                            <td>
                              {item.productSku}
                            </td>
                            <td>{item.productName}</td>
                            {listType === 'OUTBOUND' && (
                              <td>
                                {item.isReturnOrder ? (
                                  <span className='productChip return'><span className="returnCircle">R</span>{item.productCondition}</span>
                                ) : (
                                  <span className='productChip inventory'>Inventory</span>
                                )}
                              </td>
                            )}
                            <td>{item.productDescription}</td>
                            <td>{item.quantity}</td>
                          </tr>
                        ))}
                        {inventoryProductListStatus === "success" &&
                          productList.length === 0 &&
                          renderTableRow(10, "No Result Found...")}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </InfiniteScroll>
          )}
        </div>
        <div className="paletteActions mt-3">
          <button
            className="btn cus-primary-transparent-btn top-btn"
            onClick={handleCancel}
          >
            Cancel
          </button>

          <button
            className="btn cus-seconday-bg-btn top-btn addSelectedProducts"
            onClick={addSelectedProducts}
            disabled={!productList.filter(item => item.isChecked).length}
          >
            Add Products
          </button>
        </div>
        <BarcodeScannerComponent
          setShowScanner={setShowScanner}
          showScanner={showScanner}
          handleScanSuccess={handleScanSuccess}
        />
      </div>
    </Modal>
  );
};

OutboundProductListingDialog.propTypes = {
  showProductListingBox: PropTypes.bool,
  handleCancel: PropTypes.func,
  setShowProductListingBox: PropTypes.func,
  formData: PropTypes.object,
  placeholderTxt: PropTypes.string,
  listType: PropTypes.string,
  handleMultiProductSelect: PropTypes.func,
};

export default OutboundProductListingDialog;
